module.exports = __webpack_public_path__ + "img/pr-19.bc1ef35c.png";